/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_QuestionInputs */

const en_gc_search_guides_gridcraft_online_sections_7_questions_1_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will my workbook appear on another device?`)
};

const zh_gc_search_guides_gridcraft_online_sections_7_questions_1_question = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`换一台设备能看到我的工作簿吗？`)
};

/**
* | output |
* | --- |
* | "Will my workbook appear on another device?" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_7_questions_1_question = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_7_Questions_1_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_7_questions_1_question(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_7_questions_1_question(inputs)
});
export { gc_search_guides_gridcraft_online_sections_7_questions_1_question as "gc.search_guides.gridcraft_online.sections.7.questions.1.question" }